import { WEB_SERVICES } from "../../../../bitSagas/webServices";
import { USER_TYPE } from '../../../../bitConstants/constants';
import { WEBSERVICE_ERRORS } from '../../../errorCatalog';

export const getHandledErrors = (errorToPrint) => {
  const handledErrors = {
    common: {
      BUSINESS_ERRORS: {
        INCOMPATIBLE_CLIENT_PRODUCTS: errorToPrint.INCOMPATIBLE_PRODUCT,
        REDIRECT_TO_ALT_BUY_PROCESS_URL: errorToPrint.REDIRECT_TO_ALT_BUY_PROCESS_URL,
      },
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L]: errorToPrint.INCOMPATIBLE_PRODUCT,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.MAX_CARDINALITY_REACHED,
        },
        [WEB_SERVICES.EXTEND_CQ]: {
          [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L]: errorToPrint.INCOMPATIBLE_PRODUCT,
          [WEBSERVICE_ERRORS.MAX_CARDINALITY_REACHED]: errorToPrint.MAX_CARDINALITY_REACHED,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
      WEB_SERVICES_RULES: {
        [WEB_SERVICES.INIT_CQ]: {
        },
      },
    },
    [`user_${USER_TYPE.OPEN}`]: {

    },
  }

  return handledErrors;
}
